import React, { FunctionComponent } from "react";
import styles from "./ImageBlockNew.module.scss";
import ImageBlockNewProps from "./ImageBlockNewProps.interface";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";
import Image from "components/Image/Image";

const ImageBlockNew: FunctionComponent<ImageBlockNewProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const imageSizeClass = props.settings.imageSize ? styles[props.settings.imageSize] : undefined;
    const imageFit = props.settings.imageFit === "Contain" ? "contain" : "cover";

    return (
        <section className={combineClasses(styles.wrapper, imageSizeClass, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses, imageSizeClass)}>
                <div className={styles.media}>
                    {/* Media */}
                    {props.content.media ? (
                        <Image
                            wrapperClass={combineClasses(styles.image)}
                            image={props.content.media[0]?.content?.image}
                            crop={props.content.media[0].content?.crop}
                            alternativeText={props.content.media[0].content?.alternative}
                            width={{ desktop: 1500, tablet: 2500, mobile: 800 }}
                        />
                    ) : null}
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default ImageBlockNew;